@if (products().length > 0) {
  <div
    class="mb-8 md:px-5 lg:px-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3 3xl:grid-cols-4 md:gap-4 lg:gap-6 xl:gap-8"
  >
    @for (product of products(); track product; let isLast = $last) {
      <div>
        @if (product) {
          <div class="lg:min-h-176 h-full min-h-0">
            @if (product) {
              <app-product-push-v2-atom
                [product]="product"
                [isLastMobileCard]="isLast"
                [displayContext]="displayContext()"
                [isOrderingAllowed]="isOrderingAllowed()"
                [productNameColor]="productNameColor()"
                [productDescriptionColor]="productDescriptionColor()"
                [productPriceColor]="productPriceColor()"
                [productImagePlaceholderColor]="productImagePlaceholderColor()"
                [productBorderColor]="productBorderColor()"
                [productBackgroundColor]="productBackgroundColor()"
                [productHoverColors]="productHoverColors()"
                [tagColors]="tagColors()"
                (buttonClick)="requestGoToProduct.emit(product)"
              ></app-product-push-v2-atom>
            }
          </div>
        }
      </div>
    }
  </div>
}
